/**
 * @desc 注册用户
 */
import { RegisterForm } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type RegisterParameter = RegisterForm

const method = 'POST'
const url = '/auth/register'

export const registerApi = (
  data?: RegisterParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

registerApi.method = method
registerApi.url = url
